import React from 'react'
import { UNSAFE_LocationContext, MemoryRouter } from 'react-router'
import { layering } from '@mobi/component-library/Foundations'
import { trackEvent } from '@classic/Foundation/Analytics/GoogleTagManagerService'
import { OverlayOpen } from '@core/Components/Overlay'
import { Deposit, type DepositProps } from './Deposit'
import type { DepositFlow } from '@mobi/account/Areas/Deposit/typings/types'
import { appHistory } from '@core/Utils/routing/history'
import { keys } from '@classic/Foundation/Analytics/AnalyticsDataLayer'

export const openDepositModal = (flow: DepositFlow) =>
  openDeposit({
    asModal: true,
    flow,
  })

export function openDeposit(props?: DepositProps) {
  if (props?.asModal) {
    // `props` can no longer be undefined here as `asModal` must be `true`
    OverlayOpen({
      Component: () => (
        // in  RR's infinite genius, they made it so you cant nest routers because 'we said so'
        // unfortunately the way deposit is built, it cannot be tied to the parent routing context
        // and still work as a page and nested modal, so we use delete to context and make it work in
        // its own memory router context
        // https://github.com/remix-run/react-router/issues/7375#issuecomment-975431736
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, react/jsx-pascal-case
        <UNSAFE_LocationContext.Provider value={null as any}>
          <MemoryRouter>
            <Deposit asModal={props.asModal} flow={props.flow} />
          </MemoryRouter>
        </UNSAFE_LocationContext.Provider>
      ),
      layer: layering.overlayHigh,
    })
  } else {
    if (window.location.pathname !== '/deposit') {
      appHistory.push('/deposit')
    }
  }

  trackEvent(keys.setPageVisit, { customURL: '/', pageTitle: 'DEPOSIT' })
}
